export default __webpack_public_path__ + "static/media/pic75.b9b77099.jpg";